import React from 'react';
import "./NotFound.css";

export default () =>
    <div className="NotFound">
        <h3> Error 404: Sorry, Page NOT Found! </h3> 
    </div>;    


// WEBPACK FOOTER //
// ./src/containers/NotFound.js